import { useMemo } from 'react';
import styled from 'styled-components';
import { Typography, Stack } from '@mui/material';
import { Chip } from '../../../components';
import { capitalize, formatDuration } from '../../../utils/common';
import { localizeDate } from '../../../utils/datetime';
import { radius, space } from '../../../style/utils';

const TOOLTIP_PADDING_X = '22px';

const TooltipWrapper = styled(Stack)`
  background: ${({ theme }) => theme.palette.surface.base};
  border: 1px solid ${({ theme }) => theme.palette.border.muted};
  border-radius: ${radius('sm')};
  padding: ${space('xl')} ${TOOLTIP_PADDING_X};
  gap: ${space('sm')};
`;

const chipColorMap = {
  error: 'error',
  success: 'success',
} as any;

const chipLabelMap = {
  error: 'Failure',
  success: 'Success',
} as any;

const Tooltip = ({ payload }: any) => {
  const data = useMemo(() => payload?.[0]?.payload, [payload]);

  const execTimeStr = useMemo(() => {
    if (data.status === 'error') return '0 Secs';
    return formatDuration(data.execution_time);
  }, [data]);

  return (
    <TooltipWrapper>
      <Chip
        sx={{ width: 'fit-content', mb: 1 }}
        label={chipLabelMap[data.status]}
        color={chipColorMap[data.status]}
      />
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'content.secondary', width: '110px' }}>
          Execution Time:
        </Typography>
        <Typography>{execTimeStr}</Typography>
      </Stack>
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'content.secondary', width: '110px' }}>
          Materialization:
        </Typography>
        <Typography>{capitalize(data.materialization)}</Typography>
      </Stack>
      <Stack direction="row" sx={{ gap: 2 }}>
        <Typography sx={{ color: 'content.secondary', width: '110px' }}>
          Time:
        </Typography>
        <Typography>
          {localizeDate(data.time_utc).format('MMM D LT')}
        </Typography>
      </Stack>
      {data.materialization === 'incremental' && (
        <Stack direction="row" sx={{ gap: 2 }}>
          <Typography sx={{ color: 'content.secondary', width: '110px' }}>
            Full Refresh:
          </Typography>
          <Typography>{data.full_refresh ? 'True' : 'False'}</Typography>
        </Stack>
      )}
    </TooltipWrapper>
  );
};

const RunsChartTooltip = ({ active, payload }: any) => {
  if (!(active && payload?.[0]?.payload)) {
    return null;
  }

  return <Tooltip payload={payload} />;
};

export default RunsChartTooltip;
